__webpack_require__.p = "/system-email-templates/onboarding/";